// Set axios defaults to use for each request
import axios from 'axios';
axios.defaults.baseURL = indexJSVars.ajaxurl;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// Animations
import './animations/fadeInOnScroll';
import './animations/smoothScroll';
//import './animations/homepageHero';
//import './animations/privateDiningHero';
//import './animations/privateDiningHero2';

// Components
import './components/bookingWidget';
import './components/contentOverlay';
import './components/newsletterOverlay';
import './components/sectionLine';
import './components/imageSlider';
import './components/homeHeroSlider';
//import './components/homepageHero';
import './components/fixedNav';
//import './components/homepageVideoYT';
//import './components/privateDiningVideoYT';
import './components/mobileNavOverlay';
//import './components/footerRestaurantInfo';
//import './components/privateDiningHero';
//import './components/privateDiningHero2';
import './components/journalFilterMobile';
//import './components/imageLightbox';


//import Swiper styles
import '../../node_modules/swiper/swiper.scss';

//import glightbox styles & js (image lightbox)
//import '../../src/js/libraries/glightbox-master/dist/js/glightbox.min.js';
//import '../../src/js/libraries/glightbox-master/dist/css/glightbox.min.css';

// Import main scss file here. This will compile to a css file in the dist folder
import '../scss/style.scss';

